<template>
  <SearchComponent
    :category="category"
    :subcategory="subcategory"
  />
</template>

<script>
// @ is an alias to /src
import SearchComponent from "@/components/Search/Search.vue";
import { mapGetters } from "vuex";

export default {
  name: "Search",
  props: {
    category: {
      default: null,
      type: String
    },
    subcategory: {
      default: null,
      type: String
    },
    id: {
      default: null,
      type: String
    }
  },
  computed: {
    ...mapGetters({
      productBrands: "product/productBrands"
    })
  },
  components: {
    SearchComponent
  }
};
</script>
